import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import fr from 'facet-rest';
import Content from './Content';

const useStyles = buildUseStyles('ActivationAccountFundingInstructionsTemplate', () => ({
  root: {},
}));

const ActivationAccountFundingInstructionsTemplate = ({
  className,
  resource,
}) => {
  const classes = useStyles();

  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      layout={Content}
      resource={resource}
      LayoutProps={{
        resource,
      }}
      disableNextButton
      metaOverrideSet={BaseOverrideNoHidden}
    />
  );
};

ActivationAccountFundingInstructionsTemplate.defaultProps = {
  className: '',
};

ActivationAccountFundingInstructionsTemplate.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ActivationAccountFundingInstructionsTemplate;
